import { Box } from '@mui/material';
import { ReactNode } from 'react';

import { ListColumn, ListColumnProps } from '../../../components/lists/ListColumn';
import { FormattedNumber } from '../../../components/primitives/FormattedNumber';

interface ListValueColumnProps {
  symbol?: string;
  value: string | number;
  capsComponent?: ReactNode;
  disabled?: boolean;
  listColumnProps?: ListColumnProps;
}

const Content = ({
  value,
  disabled,
  capsComponent,
}: ListValueColumnProps) => {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <FormattedNumber
          value={value}
          variant="secondary14"
          sx={{ mb: 0 }}
          color={disabled ? 'text.disabled' : 'text.main'}
          symbol="USD"
        />
        {capsComponent}
      </Box>
    </>
  );
};

export const ListUniswapValueColumn = ({
  symbol,
  value,
  capsComponent,
  disabled,
  listColumnProps = {},
}: ListValueColumnProps) => {
  return (
    <ListColumn {...listColumnProps}>
      <Content
        symbol={symbol}
        value={value}
        capsComponent={capsComponent}
        disabled={disabled}
      />
    </ListColumn>
  );
};
